import React from 'react';
import ReactDOM from 'react-dom';
import Chat from './components/Chat';
import Login from './components/login/Login';
import Forbidden from './components/Forbidden';

import createStore from './config/configureStore';
import { Provider } from 'react-redux';
import firebase from 'firebase';
import { BrowserRouter, Route, HashRouter, Switch } from 'react-router-dom';

function getFirebaseConfig()
{
    if (window.__DEV__) {
        return {
            apiKey: "AIzaSyBvF4DOltS1bppkl64fYQijk7dv9CDbJYY",
            authDomain: "testchatowlidiretivasseguranca.firebaseapp.com",
            databaseURL: "https://testchatowlidiretivasseguranca-default-rtdb.firebaseio.com",
            projectId: "testchatowlidiretivasseguranca",
            storageBucket: "testchatowlidiretivasseguranca.appspot.com",
            messagingSenderId: "269894267262",
            appId: "1:269894267262:web:35f21590153c04f4e8432f",
            measurementId: "G-YJ6D8CXFCC"
        };
    }

    return {
        apiKey: "AIzaSyBe8zzerr7oCNdaNC9XnV41NyIBoCz2wEE",
        authDomain: "owli-chat-v2.firebaseapp.com",
        databaseURL: "https://owli-chat-v2-default-rtdb.firebaseio.com",
        projectId: "owli-chat-v2",
        storageBucket: "owli-chat-v2.appspot.com",
        messagingSenderId: "288274648115",
        appId: "1:288274648115:web:e7b5f360f223991023e746",
        measurementId: "G-HZYJ7FC67P"
    };
}

firebase.initializeApp(getFirebaseConfig());

const store = createStore();

ReactDOM.render(
    <Provider store={store}>
        <React.Fragment>
            <BrowserRouter hashHistory={HashRouter}>
                <Switch>
                    <Route path="/" exact component={Login} />
                    <Route path="/chat" exact component={Chat} />
                    <Route path="/403" exact component={Forbidden} />
                </Switch>
            </BrowserRouter>
        </React.Fragment>
    </Provider>
    ,
    document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js